<h1 matDialogTitle>{{header}}</h1>
<div mat-dialog-content [innerHTML]="confirmMessage"></div>
<div mat-dialog-actions class="pt-24 pb-24">
    <div fxFlex style="flex:1" class="text-center">
        <button mat-raised-button class="mat-accent" [ngClass]="cancel ? 'mr-16' : ''"
            (click)="dialogRef.close(true)">{{ confirm }}</button>
        <button mat-button *ngIf="cancel" (click)="dialogRef.close(false)">{{ cancel }}</button>
    </div>
</div>